<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="usuarios"
        :search="search"
        sort-by="calories"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Usuarios</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="green"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="generarExcelUsuarios()"
                >
                  <v-icon>fas fa-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Generar excel</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="nombre"
                          label="NOMBRE"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          v-model="idRol"
                          :items="roles"
                          label="ROLES"
                          outlined
                          dense
                          hide-details
                        >
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="email"
                          label="Usuario"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="password"
                          label="CONTRASEÑA"
                          type="password"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-show="valida">
                        <div
                          class="red--text"
                          v-for="v in validaMensaje"
                          :key="v"
                          v-text="v"
                        ></div>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-divider></v-divider>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <div class="subtitle-1 font-weight-bold">
                          Permisos Compartido
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="nombre_compartido_area"
                          :items="items_compartido_area"
                          label="Carpeta área"
                          outlined
                          dense
                          hide-details
                          @input="listarPermisosCompartido()"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="nombres_compartido_tipo"
                          :items="items_compartido_tipo"
                          item-text="nombre"
                          label="Carpeta tipo"
                          chips
                          small-chips
                          multiple
                          outlined
                          dense
                          hide-details
                          return-object
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <v-data-table
                          :headers="headres_nombre_comp_tipo"
                          :items="nombres_compartido_tipo"
                          dense
                        >
                          <template v-slot:[`item.action_delete`]="{ item }">
                            <v-icon
                              v-if="item.id_permisos_compartido_tipo"
                              class="mr-2"
                              @click="eliminarPermisoCompartido(item)"
                            >
                              fas fa-trash-alt
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-btn
                    color="primary"
                    v-if="flag_creds_one_drive"
                    @click="dialog_delete_oneOdrive = true"
                    >ONE DRIVE</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn color="cancel" @click="close">CANCELAR</v-btn>
                  <v-btn color="success" @click="guardar">GUARDAR</v-btn>
                </v-card-actions>
              </v-card>

              <!-- PreLoader -->
              <v-overlay v-model="overlayNuevo" z-index="0">
                <lottie-player
                  v-if="true"
                  src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
                  background="transparent"
                  speed="1"
                  style="width: 300px; height: 300px"
                  loop
                  autoplay
                ></lottie-player>
              </v-overlay>
            </v-dialog>

            <v-dialog v-model="addModal" max-width="350px">
              <v-card>
                <v-card-title class="headline" v-if="addAccion == 1"
                  >¿Activar Item?</v-card-title
                >
                <v-card-title class="headline" v-if="addAccion == 2"
                  >Desactivar Item?</v-card-title
                >
                <v-card-text>
                  Estas a punto de
                  <span v-if="addAccion == 1">activar</span>
                  <span v-if="addAccion == 2">desactivar</span>
                  a {{ addNombre }}
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="cancel" @click="ActivarDesactivarCerrar">
                    Cancelar
                  </v-btn>
                  <v-btn v-if="addAccion == 1" color="success" @click="activar">
                    Activar
                  </v-btn>
                  <v-btn
                    v-if="addAccion == 2"
                    color="warning"
                    @click="desactivar"
                  >
                    Desactivar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_delete_oneOdrive" max-width="600">
              <v-card>
                <v-card-title
                  >¿Eliminar las claves one drive de
                  {{ nombre }} ?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="red"
                    dark
                    @click="eliminarCredencialesOneDrive()"
                    >Eliminar</v-btn
                  >
                  <v-btn color="grey" @click="dialog_delete_oneOdrive = false"
                    >Cancelar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.action_editar`]="{ item }">
          <v-icon class="mr-2" @click="editItem(item)"> edit </v-icon>
        </template>

        <template v-slot:[`item.action_desactivar`]="{ item }">
          <template v-if="item.condicion">
            <v-icon @click="ActivarDesactivar(2, item)"> block </v-icon>
          </template>
          <template v-else>
            <v-icon @click="ActivarDesactivar(1, item)"> check </v-icon>
          </template>
        </template>

        <template v-slot:[`item.condicion`]="{ item }">
          <v-chip :color="getColorCondicion(item.condicion)" dark>
            <div v-if="item.condicion"><span>Activo</span></div>
            <div v-else><span>Inactivo</span></div>
          </v-chip>
        </template>
      </v-data-table>

      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackError" color="cyan darken-2" top>{{
        mensaje_snackbar
      }}</v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";

export default {
  data() {
    return {
      dialog: false,
      usuarios: [],
      headers: [
        { text: "Nombre", value: "nombre", sortable: true },
        { text: "Rol", value: "rol", sortable: true },
        { text: "Usuario", value: "email", sortable: true },
        { text: "Estado", align: "left", value: "condicion", sortable: true },
        {
          text: "Editar",
          value: "action_editar",
          sortable: false,
          align: "center",
        },
        {
          text: "Desactivar",
          value: "action_desactivar",
          sortable: false,
          align: "center",
        },
      ],
      search: "",
      editedIndex: -1,
      id: "",
      idRol: "",
      roles: [],
      nombre: "",
      email: "",
      password: "",
      actPassword: false,
      passwordAnt: "",
      valida: 0,
      validaMensaje: [],
      addModal: 0,
      addAccion: 0,
      addNombre: "",
      addId: "",
      overlay: true,
      overlayNuevo: false,
      snackError: false,
      mensaje_snackbar: "",
      flag_creds_one_drive: false,
      dialog_delete_oneOdrive: false,
      //PERMISOS COMPARTIDO
      items_compartido_area: [
        "ADMINISTRACIÓN",
        "FINANZAS",
        "GERENCIA",
        "INFORMÁTICA",
        "LEGAL",
        "OPERACIONES",
      ],
      nombre_compartido_area: "",
      items_compartido_tipo: [
        { nombre: "FORMULARIOS" },
        { nombre: "PRESENTACIONES" },
        { nombre: "PROCEDIMIENTOS" },
        { nombre: "PROCESOS" },
        { nombre: "MANUALES" },
      ],
      nombres_compartido_tipo: [],
      headres_nombre_comp_tipo: [
        { text: "Nombre", value: "nombre" },
        { text: "Remover", value: "action_delete" },
      ],
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo" : "Actualizar";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.select();
  },
  methods: {
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Usuarios/Listar", configuracion)
        .then(function (response) {
          me.usuarios = response.data;
          if (response.status == 200) {
            me.overlay = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    select() {
      let me = this;
      var rolesArray = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Roles/Select", configuracion)
        .then(function (response) {
          rolesArray = response.data;
          rolesArray.map(function (x) {
            me.roles.push({ text: x.nombre, value: x.idRol });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getColorCondicion(condicion) {
      if (condicion == true) {
        return "green";
      } else {
        return "red";
      }
    },
    editItem(item) {
      this.id = item.idUsuario;
      this.idRol = item.idRol;
      this.nombre = item.nombre;
      this.email = item.email;
      this.password = item.password_hash;
      this.passwordAnt = item.password_hash;
      this.editedIndex = 1;
      this.dialog = true;

      this.clavesOneDrive(item.idUsuario);
    },
    clavesOneDrive(id) {
      axios.get("api/DriveLlaves/Listar/" + id).then((response) => {
        this.flag_creds_one_drive = response.data.length > 0 ? true : false;
      });
    },
    eliminarCredencialesOneDrive() {
      axios
        .delete("api/DriveLlaves/Eliminar/" + this.id)
        .then(() => {
          this.dialog_delete_oneOdrive = false;
          this.dialog = false;
          this.mensaje_snackbar = "Credenciales eliminadas correctamente";
          this.snackError = true;
          this.close();
          this.listar();
        })
        .catch(() => {
          me.snackError = true;
          me.mensaje_snackbar =
            "SUCEDIO ALGUN ERROR, VERIFICAR ESTADO DE CONEXIÓN, Y VUELVA A INTENTAR.";
        });
    },
    ActivarDesactivar(accion, item) {
      this.addModal = 1;
      this.addNombre = item.nombre;
      this.addId = item.idUsuario;
      if (accion == 1) {
        this.addAccion = 1;
      } else if (accion == 2) {
        this.addAccion = 2;
      } else {
        this.addModal = 0;
      }
    },
    ActivarDesactivarCerrar() {
      this.addModal = 0;
    },
    close() {
      this.dialog = false;
      this.nombre_compartido_area = "";
      this.nombres_compartido_tipo = [];
      this.limpiar();
    },
    limpiar() {
      this.id = "";
      this.idRol = "";
      this.nombre = "";
      this.email = "";
      this.password = "";
      this.passwordAnt = "";
      this.actPassword = false;
      this.editedIndex = -1;
    },
    guardar() {
      if (this.validar()) {
        return;
      }
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (this.editedIndex > -1) {
        //codigo para editar
        let me = this;
        if (me.password != me.passwordAnt) {
          me.actPassword = true;
        }
        me.overlayNuevo = true;
        axios
          .put(
            "api/Usuarios/Actualizar",
            {
              idUsuario: me.id,
              idRol: me.idRol,
              nombre: me.nombre,
              email: me.email,
              password: me.password,
              act_password: me.actPassword,
            },
            configuracion
          )
          .then(function (response) {
            me.listar();
            me.overlayNuevo = false;
            me.mensaje_snackbar = "DATOS ACTUALIZADOS";
            me.overlayNuevo = false;
            me.crearPermisosCompartido(me.id);
          })
          .catch(function (error) {
            console.log(error);
            me.overlayNuevo = false;
            me.snackError = true;
            me.mensaje_snackbar =
              "SUCEDIO ALGUN ERROR, VERIFICAR ESTADO DE CONEXIÓN, Y VUELVA A INTENTAR.";
          });
      } else {
        let me = this;
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };
        me.overlayNuevo = true;
        axios
          .post(
            "api/Usuarios/Crear",
            {
              idRol: me.idRol,
              nombre: me.nombre,
              email: me.email,
              password: me.password,
            },
            configuracion
          )
          .then(function (response) {
            //me.close();
            me.listar();
            me.limpiar();
            me.overlayNuevo = false;
            me.mensaje_snackbar = "DATOS GUARDADOS";
            me.snackError = true;
            me.crearPermisosCompartido(response.data);
          })
          .catch(function (error) {
            console.log(error);
            me.overlayNuevo = false;
            me.snackError = true;
            me.mensaje_snackbar =
              "SUCEDIO ALGUN ERROR, VERIFICAR ESTADO DE CONEXIÓN, Y VUELVA A INTENTAR.";
          });
      }
    },
    listarPermisosCompartido() {
      if (!this.id) {
        return;
      }

      axios
        .get(
          "api/PermisosCompartidoAreas/ListarPorNombre/" +
            this.id +
            "/" +
            this.nombre_compartido_area
        )
        .then((response) => {
          this.nombres_compartido_tipo = [];
          response.data.forEach((element) => {
            this.nombres_compartido_tipo.push({
              id_permisos_compartido_area: element.id_permisos_compartido_area,
              id_permisos_compartido_tipo: element.id_permisos_compartido_tipo,
              nombre: element.nombre_tipo,
            });
          });
        });
    },
    crearPermisosCompartido(id_usuario) {
      //console.log(this.nombres_compartido_tipo);
      var flag = false;
      var id_permisos_compartido_area = 0;
      //VERIFICA SI EXISTE ALMENOS UN PERMISO CREADO
      this.nombres_compartido_tipo.forEach((element) => {
        if (element.id_permisos_compartido_tipo != undefined) {
          id_permisos_compartido_area = element.id_permisos_compartido_area;
          flag = true;
        }
      });
      if (flag) {
        //SI EXISTIA UN PERMISO YA CREADO ENTONCES SOLO CREA LOS NUEVOS
        this.crearPermisosCompartidoTipo(id_permisos_compartido_area);
      } else {
        if (
          this.nombre_compartido_area != "" &&
          this.nombres_compartido_tipo.length > 0
        ) {
          axios
            .post("api/PermisosCompartidoAreas/Crear", {
              idUsuario: id_usuario,
              nombre: this.nombre_compartido_area,
              tipos: this.nombres_compartido_tipo,
            })
            .then(() => {
              this.listarPermisosCompartido();
              this.close();
            });
        }
      }
    },
    crearPermisosCompartidoTipo(id_permisos_compartido_area) {
      this.nombres_compartido_tipo.forEach((element) => {
        if (element.id_permisos_compartido_tipo == undefined) {
          axios
            .post("api/PermisosCompartidoTipos/Crear", {
              id_permisos_compartido_area: id_permisos_compartido_area,
              nombre: element.nombre,
            })
            .then(() => {
              this.listarPermisosCompartido();
            });
        }
      });
    },
    eliminarPermisoCompartido(item) {
      //console.log(item);
      var flag_area = false;
      if (this.nombres_compartido_tipo.length == 1) {
        flag_area = true;
      }
      axios
        .delete(
          "api/PermisosCompartidoTipos/Eliminar/" +
            item.id_permisos_compartido_tipo
        )
        .then(() => {
          this.mensaje_snackbar = "Eliminado correctamente";
          this.snackError = true;
          this.listarPermisosCompartido();
          if (flag_area) {
            this.eliminarPermisoCompartirArea(item.id_permisos_compartido_area);
          }
        });
    },
    eliminarPermisoCompartirArea(id_permisos_compartido_area) {
      axios
        .delete(
          "api/PermisosCompartidoAreas/Eliminar/" + id_permisos_compartido_area
        )
        .then(() => {
          this.listarPermisosCompartido();
        });
    },
    validar() {
      this.valida = 0;
      this.validaMensaje = [];

      if (this.nombre <= 3) {
        this.validaMensaje.push(
          "El nombre no debe ser menor a 3 digitos ni mayor de 55 digitos."
        );
      }
      if (!this.idRol) {
        this.validaMensaje.push("Seleccione un rol.");
      }
      if (!this.email) {
        this.validaMensaje.push("Ingrese un email.");
      }
      if (!this.password) {
        this.validaMensaje.push("Ingrese una contraseña.");
      }
      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    activar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/Usuarios/Activar/" + this.addId, {}, configuracion)
        .then(function (response) {
          me.addModal = 0;
          me.addAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    desactivar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/Usuarios/Desactivar/" + this.addId, {}, configuracion)
        .then(function (response) {
          me.addModal = 0;
          me.addAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    generarExcelUsuarios() {
      let usuarios = [];
      this.usuarios.forEach((element) => {
        usuarios.push({
          Nombre: element.nombre,
          Usuario: element.usuario,
          Estado: this.estadoUsuario(element.condicion),
          Rol: element.rol,
        });
      });

      let data = XLSX.utils.json_to_sheet(usuarios);
      const workbook = XLSX.utils.book_new();
      const filename = "Usuarios";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    estadoUsuario(status) {
      if (status) {
        return "Activo";
      } else {
        return "Desactivado";
      }
    },
  },
};
</script>
